import { render, staticRenderFns } from "./ZFormEditar.vue?vue&type=template&id=18681c5b&"
import script from "./ZFormEditar.vue?vue&type=script&lang=js&"
export * from "./ZFormEditar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports